<template>
  <path
    class="Bar"
    :class="{ 'Bar--negative': isNegative }"
    :d="rightRoundedRect"
    :fill="datum.fill"
    @click="onClick"
    @mouseover="onMouseover"
    @mouseout="onMouseout"
  />
</template>

<script>
import Datum from './datum.vue';

const safeNumber = (x) => Math.max(0, Number.isNaN(x) ? 0 : x);

export default {
  name: 'DatalasBar',
  extends: Datum,
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    isNegative: {
      type: Boolean,
      default: false,
    },
    radius: {
      type: Number,
      default: 0,
    },
    isHorizontal: Boolean,
  },
  computed: {
    safeWidth() {
      return safeNumber(this.width);
    },
    safeHeight() {
      return safeNumber(this.height);
    },
    isTopLeftRounded() {
      return (
        (!this.isHorizontal && !this.isNegative) ||
        (this.isHorizontal && this.isNegative)
      );
    },
    isTopRightRounded() {
      return (this.isHorizontal || !this.isHorizontal) && !this.isNegative;
    },
    isBottomLeftRounded() {
      return this.isNegative;
    },
    isBottomRightRounded() {
      return (
        (this.isHorizontal && !this.isNegative) ||
        (!this.isHorizontal && this.isNegative)
      );
    },
    rightRoundedRect() {
      let retval;
      retval = `M${this.x + this.radius},${this.y}`;
      retval += `h${this.safeWidth - 2 * this.radius}`;
      if (this.isTopRightRounded) {
        retval += `a${this.radius},${this.radius} 0 0 1 ${this.radius},${this.radius}`;
      } else {
        retval += `h${this.radius}`;
        retval += `v${this.radius}`;
      }
      retval += `v${this.safeHeight - 2 * this.radius}`;
      if (this.isBottomRightRounded) {
        retval += `a${this.radius},${this.radius} 0 0 1 ${-this.radius},${
          this.radius
        }`;
      } else {
        retval += `v${this.radius}`;
        retval += `h${-this.radius}`;
      }
      retval += `h${2 * this.radius - this.safeWidth}`;
      if (this.isBottomLeftRounded) {
        retval += `a${this.radius},${this.radius} 0 0 1 ${-this.radius},${-this
          .radius}`;
      } else {
        retval += `h${-this.radius}`;
        retval += `v${-this.radius}`;
      }
      retval += `v${2 * this.radius - this.safeHeight}`;
      if (this.isTopLeftRounded) {
        retval += `a${this.radius},${this.radius} 0 0 1 ${this.radius},${-this
          .radius}`;
      } else {
        retval += `v${-this.radius}`;
        retval += `h${this.radius}`;
      }
      retval += 'z';
      return retval;
    },
  },
};
</script>
